import Vue from "vue";
import Vuex from "vuex";
import shop from "./shop";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {}, // 用户信息
    isLogin: false, // 是否已登录
    routerList: [], // 路由路径
    // 新增：页面状态管理
    pageStates: {}, // 存储各个页面的状态
  },
  mutations: {
    setUser(state, data) {
      state.user = data;
      if (Object.keys(data).length > 0) {
        state.isLogin = true;
      } else {
        state.isLogin = false;
      }
    },
    setRouterList(state, router) {
      let flag = false;
      state.routerList.forEach((item) => {
        if (item.name == router.name) {
          flag = true;
        }
      });
      if (!flag) {
        state.routerList.push(router);
      }
    },
    // 新增：保存页面状态
    savePageState(state, { pageName, data }) {
      state.pageStates[pageName] = {
        ...data,
        timestamp: Date.now()
      };
    },
    // 新增：清除页面状态
    clearPageState(state, pageName) {
      if (pageName) {
        delete state.pageStates[pageName];
      } else {
        state.pageStates = {};
      }
    },
    // 新增：更新页面状态
    updatePageState(state, { pageName, data }) {
      if (state.pageStates[pageName]) {
        state.pageStates[pageName] = {
          ...state.pageStates[pageName],
          ...data,
          timestamp: Date.now()
        };
      }
    }
  },
  actions: {},
  getters: {
    // 新增：获取页面状态
    getPageState: (state) => (pageName) => {
      return state.pageStates[pageName] || null;
    },
    // 新增：检查页面状态是否存在且未过期
    isPageStateValid: (state) => (pageName, maxAge = 30 * 60 * 1000) => {
      const pageState = state.pageStates[pageName];
      if (!pageState) return false;
      
      const now = Date.now();
      const age = now - pageState.timestamp;
      return age < maxAge; // 默认30分钟过期
    }
  },
  modules: {
    shop,
  },
});
